import { createRichTextFormFieldSchema, richTextHtmlToState } from "@tournated-com/ui";

/** Reused across calls — building the schema is not free and it holds no state. */
const nonEmptyRichTextSchema = createRichTextFormFieldSchema({ optional: false });

/**
 * Seeds a `RichTextFormField` from a column that may still hold legacy markup.
 *
 * The editor's value is a serialized Lexical state, but rows written before it
 * existed hold WYSIWYG HTML. A stored value that parses as JSON is already
 * Lexical and passes through untouched; anything else is run through
 * `richTextHtmlToState`, which preserves the legacy formatting instead of
 * flattening it to a single plain-text paragraph.
 *
 * Empty stays empty, so a field that was never filled does not start out
 * holding an "empty editor state" blob.
 */
export const toRichTextFieldValue = (stored: string | null | undefined): string => {
  if (!stored?.trim()) return "";

  try {
    JSON.parse(stored);
    return stored;
  } catch {
    return richTextHtmlToState(stored);
  }
};

/**
 * True when a rich-text field holds nothing the reader would see. An untouched
 * editor still serializes a non-empty state blob, so a plain `!value` check
 * would send that blob to the API as if it were content.
 */
export const isRichTextFieldValueEmpty = (value: string): boolean =>
  !nonEmptyRichTextSchema.safeParse(value).success;
